<ng-container *ngIf="comments.data && comments.data.length;else dataEmpty">
  <ng-container *ngFor="let comment of comments.data ; let commentIndex = index">
    <div class="repliesAndComments">
      <ng-container *ngTemplateOutlet="commentTemplate,context:{comment:comment}">
      </ng-container>
    </div>
    <ng-container *ngIf="comment.replies">
      <ng-container *ngFor="
          let replay of isRepliesExpanded(comment.id)
            ? comment.replies
            : getVisibleReplies(comment.replies);
          let replayIndex = index
        ">
        <div class="repliesAndComments replies">
          <ng-container *ngTemplateOutlet="commentTemplate,context:{comment:replay}">
          </ng-container>
        </div>
      </ng-container>
      <div class="show-more-replies" *ngIf="hasMoreReplies(comment.replies)" (click)="toggleReplies(comment.id)">
        <a>
          <span>{{
            (isRepliesExpanded(comment.id)
            ? "general.showFewerReplies"
            : "general.showMoreReplies"
            ) | translate
            }}</span>
        </a>
      </div>
    </ng-container>
    <ng-container *ngIf="activeAddedReplay && activeAddedReplay == comment.id">
      <app-complaint-comment-controls *ngIf="comments.canAddComment" [recordId]="recordId" [isReplay]="true"
        [selectedRecord]="selectedComment" [id]="'form-replay' + comment.id" (submitComment)="submitComment($event)">
      </app-complaint-comment-controls>
    </ng-container>
  </ng-container>
  <div *ngIf="commentsLoading" class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <div class="show-more-replies comments" *ngIf="!isButtonActive()">
    <button type="button" (click)="getComments(true)" [class.loading]='loading' [disabled]='loading'>
      <span>{{ "general.showMore" | translate }}</span>
    </button>
  </div>
</ng-container>
<app-complaint-comment-controls *ngIf="comments.canAddComment" (submitComment)="submitComment($event , false)"
  [recordId]="recordId"></app-complaint-comment-controls>

<ng-template #commentTemplate let-comment="comment">
  <div class="d-flex align-items-center justify-content-between">
    <div class="name-with-image-rounded">
      <div class="image-rounded image-circle">
        <div class="image">
          <img *ngIf="comment.logo" [src]="comment.logo" (error)="comment.logo = ''" />
          <span *ngIf="!comment.logo">
            {{ comment.createdBy | shortName }}
          </span>
        </div>
      </div>
      <div class="name">
        <h5>{{ comment.createdBy }}</h5>
        <p>{{ comment.createdDate | date : "d MMMM y - h:mm a" }}</p>
      </div>
    </div>
    <div class="actions" *ngIf="selectedComment?.id != comment.id">
      <button mat-icon-button *ngIf="comment.canEdit" (click)="selectedComment = comment;activeAddedReplay = 0">
        <svg id="edit_ic" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <rect id="Container" width="24" height="24" fill="none" />
          <path id="edit"
            d="M134.27-844.586l-3.721-3.683,1.226-1.227a1.68,1.68,0,0,1,1.237-.5,1.68,1.68,0,0,1,1.237.5l1.226,1.227a1.739,1.739,0,0,1,.525,1.217,1.586,1.586,0,0,1-.482,1.217ZM120.875-834a.846.846,0,0,1-.624-.252.849.849,0,0,1-.252-.625v-2.477a.907.907,0,0,1,.066-.34.876.876,0,0,1,.2-.3l9.017-9.031L133-843.292l-9.017,9.031a.875.875,0,0,1-.3.2.9.9,0,0,1-.339.066Z"
            transform="translate(-116 854)" fill="#6b6d85" />
        </svg>
      </button>
      <button mat-icon-button *ngIf="comment.canDelete" (click)="deleteComment(comment)">
        <svg id="ic_delete" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path id="Path_19035" data-name="Path 19035" d="M0,0H24V24H0Z" fill="none" />
          <path id="ic_delete-2" data-name="ic_delete"
            d="M56.917,3H54.592a3.757,3.757,0,0,0-3.675-3h-1.5a3.757,3.757,0,0,0-3.675,3H43.417a.75.75,0,0,0,0,1.5h.75v9.75A3.755,3.755,0,0,0,47.917,18h4.5a3.755,3.755,0,0,0,3.75-3.75V4.5h.75a.75.75,0,0,0,0-1.5Zm-7.5,9.75a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0v4.5Zm3,0a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0ZM47.3,3a2.255,2.255,0,0,1,2.122-1.5h1.5A2.255,2.255,0,0,1,53.039,3Z"
            transform="translate(-38.167 3)" fill="#dc3545" />
        </svg>
      </button>
    </div>
  </div>
  <ng-container *ngIf="selectedComment?.id != comment.id">
    <div class="comments">
      <p [innerText]="comment.comment"></p>
      <span class="sentTo" *ngIf="comment.isCreator && comment.sendTo">
        {{ "forms.sentTo" | translate }}
        <strong>{{ comment.sendTo[0].name }}</strong>
      </span>
    </div>
    <div class="add_replay" *ngIf="comment.canAddReply">
      <ng-container *ngIf="activeAddedReplay && activeAddedReplay == comment.id">
        <a (click)="activeAddedReplay = 0">
          {{ "complaint.cancelAddReply" | translate }}
        </a>
      </ng-container>
      <ng-container
        *ngIf="(!activeAddedReplay || (activeAddedReplay && activeAddedReplay != comment.id)) && !comment.isReply">
        <a (click)="addReplay(comment.id)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
            <path id="reply_ic"
              d="M12.293,3.293a1,1,0,0,0,0,1.414L14.586,7H9a7,7,0,0,0-7,7v2a1,1,0,0,0,2,0V14A5,5,0,0,1,9,9h5.586l-2.293,2.293a1,1,0,1,0,1.414,1.414l4-4a1,1,0,0,0,0-1.414l-4-4a1,1,0,0,0-1.414,0Z"
              transform="translate(-2 -3)" fill="#91aec0" fill-rule="evenodd" />
          </svg>
          {{ "complaint.addReply" | translate }}
        </a>
      </ng-container>
    </div>
  </ng-container>
  <app-complaint-comment-controls *ngIf="comments.canAddComment && selectedComment?.id == comment.id"
    (cancelEdit)="selectedComment = null" [recordId]="recordId" [selectedRecord]="selectedComment"
    (submitComment)="submitComment($event , comment.isReply ? true : false)"
    [isReplay]="!!selectedComment?.isReply"></app-complaint-comment-controls>
</ng-template>


<ng-template #dataEmpty>
  <empty-state [img]="'assets/images/illu_empty_state.png'" [hideTitle]="true"
    [desc]='"general.noCommentsAdded"|translate'></empty-state>
</ng-template>